import * as actionTypes from './actionTypes';

export const storeEnterpriseObjectives = (list) => {
  return {
    type : actionTypes.STORE_ENTERPRISE_OBJECTIVES,
    val : list
  }
}

export const getEnterpriseActions = (list) => {
  return {
    type : actionTypes.GET_ENTERPRISEOBJECTIVE_ASSOCIATED_ACTIONS,
    val : list
  }
}

export const resetEnterpriseObjectives = () => {
  return {
    type : actionTypes.RESET_OBJECTIVES
  }
}

export const resetEnterpriseActions = () => {
  return {
    type : actionTypes.RESET_OBJECTIVE_ACTIONS
  }
}